module.exports = __webpack_public_path__ + "d73a4a00f1f5ce2ba776e01c271b6a9b.png";


//////////////////
// WEBPACK FOOTER
// ./images/pics2/0.png
// module id = 292
// module chunks = 0